export const TEST_IDS = {
  onboarding: {
    getStarted: 'onboarding-get-started-button',
    demo: 'onboarding-demo-button',
  },
  auth: {
    nameInput: 'auth-name-input',
    emailInput: 'auth-email-input',
    passwordInput: 'auth-password-input',
    submit: 'auth-submit-button',
    demo: 'auth-demo-button',
    toggle: 'auth-toggle-mode-button',
  },
  nav: {
    dashboard: 'nav-dashboard',
    goals: 'nav-goals',
    tasks: 'nav-tasks',
    projects: 'nav-projects',
    ai: 'nav-ai',
  },
  dashboard: {
    mainFocus: 'dashboard-main-focus-card',
    topPriorities: 'dashboard-top-priorities-list',
    activeGoals: 'dashboard-active-goals-carousel',
    projects: 'dashboard-projects-attention-card',
    finance: 'dashboard-finance-snapshot-card',
    habits: 'dashboard-habit-preview-card',
    aiNextStep: 'dashboard-ai-next-step-card',
    moreMenu: 'dashboard-more-menu',
  },
};
